import { render, staticRenderFns } from "./HelloFooter.vue?vue&type=template&id=673ac254&scoped=true"
import script from "./HelloFooter.vue?vue&type=script&lang=js"
export * from "./HelloFooter.vue?vue&type=script&lang=js"
import style0 from "./HelloFooter.vue?vue&type=style&index=0&id=673ac254&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "673ac254",
  null
  
)

export default component.exports